module.exports = __webpack_public_path__ + "img/072.c4f9141c.png";